export class LibroFacturasRecibidas {
    emisor: string;
    CIF: string;
    pais: string;
    provincia: string;
    fechaFactura: Date;
    numeroFactura: string;
    base: number;
    impuesto1: string;
    impuesto2: string;
    total: number;
    cuentaContable: string;
    fechaPago: Date;
    forma: string;
    cajaCuenta: string;
    toImport: boolean;
    idContactImport: number;
    client: boolean;

    constructor() { }
} 

export class LibroFacturasEmitidas {
    nombreCliente: string;
    pais: string;
    provincia: string;
    CIF: string;
    fechaFactura: Date;
    vencimiento: Date;
    cuentaContrable: string;
    tipoDeCobro: string;
    cuentaEfectivo: string;
    concepto: string;
    base: number;
    impuesto1: string;
    impuesto2: string;
    toImport: boolean;
    idContactImport: number;
    client: boolean;
    constructor() {}
}

